export const palette_3m_1080 = {
    "#ffffff" : {
        display: "Kaplama Yok",
        name: "Stok Kodu: AAAAAA",
        material: "01_default",
    },
    "#f44336" : {
        display: "Uzaysal Turuncu 3M 1080 Light Serisi",
        name: "Stok Kodu: AAAAAA",
        material: "01_default",
    },
    "#e91e63" : {
        display: "Pictorial Carmine 3M 1080 Light  Serisi",
        name: "Stok Kodu: AAAAAA",
        material: "01_default",
    },
    "#9c27b0" : {
        display: "Amethyst Mor 3M 1080 Light  Serisi",
        name: "Stok Kodu: AAAAAA",
        material: "01_default",
    },
    "#673ab7" : {
        display: "Konstantinapol 3M 1080 Light Serisi",
        name: "Stok Kodu: AAAAAA",
        material: "01_default",
    },
    "#3f51b5" : {
        display: "Gök Mavisi 3M 1080 Light Serisi",
        name: "Stok Kodu: AAAAAA",
        material: "01_default",
    },
    "#2196f3" : {
        display: "Soylu Safir 3M 1080 Light Serisi",
        name: "Stok Kodu: AAAAAA",
        material: "01_default",
    },
    "#03a9f4" : {
        display: "Deniz Mavisi 3M 1080 Light Serisi",
        name: "Stok Kodu: AAAAAA",
        material: "01_default",
    },
    "#00bcd4" : {
        display: "Turkuaz 3M 1080 Light Serisi",
        name: "Stok Kodu: AAAAAA",
        material: "01_default",
    },
    "#009688" : {
        display: "Meşe Ağacı 3M 1080 Light Serisi",
        name: "Stok Kodu: AAAAAA",
        material: "01_default",
    },
    "#4caf50" : {
        display: "Pistachio 3M 1080 Light Serisi",
        name: "Stok Kodu: AAAAAA",
        material: "01_default",
    },
    "#8bc34a" : {
        display: "Eyfel Kulesi 3M 1080 Light Serisi",
        name: "Stok Kodu: AAAAAA",
        material: "01_default",
    },
    "#cddc39" : {
        display: "Fıstık Yeşili 3M 1080 Light Serisi",
        name: "Stok Kodu: AAAAAA",
        material: "01_default",
    },
    "#ffeb3b" : {
        display: "Portland 3M 1080 Light  Serisi",
        name: "Stok Kodu: AAAAAA",
        material: "01_default",
    },
    "#ffc107" : {
        display: "Umutsuz Günbatımı 3M 1080 Light Serisi",
        name: "Stok Kodu: AAAAAA",
        material: "01_default",
    },
    "#ff9800" : {
        display:"Balkabağı 3M 1080 Light Serisi",
        name: "Stok Kodu: AAAAAA",
        material: "01_default",
    },
    "#ff5722" : {
        display: "Yanardağ Kırmızısı 3M 1080 Light Serisi",
        name: "Stok Kodu: AAAAAA",
        material: "01_default",
    },
    "#607d8b" : {
        display: "Palatin Gri 3M 1080 Light Serisi",
        name: "Stok Kodu: AAAAAA",
        material: "01_default",
    },
    "#f14336" : {
        display: "Uzaysal Turuncu 3M 1080 Light Serisi",
        name: "Stok Kodu: AAAAAA",
        material: "01_default",
    },
    "#e11e63" : {
        display: "Pictorial Carmine 3M 1080 Light  Serisi",
        name: "Stok Kodu: AAAAAA",
        material: "01_default",
    },
    "#9127b0" : {
        display: "Amethyst Mor 3M 1080 Light  Serisi",
        name: "Stok Kodu: AAAAAA",
        material: "01_default",
    },
    "#613ab7" : {
        display: "Konstantinapol 3M 1080 Light Serisi",
        name: "Stok Kodu: AAAAAA",
        material: "01_default",
    },
    "#3151b5" : {
        display: "Gök Mavisi 3M 1080 Light Serisi",
        name: "Stok Kodu: AAAAAA",
        material: "01_default",
    },
    "#2296f3" : {
        display: "Soylu Safir 3M 1080 Light Serisi",
        name: "Stok Kodu: AAAAAA",
        material: "01_default",
    },
    "#01a9f4" : {
        display: "Deniz Mavisi 3M 1080 Light Serisi",
        name: "Stok Kodu: AAAAAA",
        material: "01_default",
    },
    "#01bcd4" : {
        display: "Turkuaz 3M 1080 Light Serisi",
        name: "Stok Kodu: AAAAAA",
        material: "01_default",
    },
    "#019688" : {
        display: "Meşe Ağacı 3M 1080 Light Serisi",
        name: "Stok Kodu: AAAAAA",
        material: "01_default",
    },
    "#41af50" : {
        display: "Pistachio 3M 1080 Light Serisi",
        name: "Stok Kodu: AAAAAA",
        material: "01_default",
    },
    "#81c34a" : {
        display: "Eyfel Kulesi 3M 1080 Light Serisi",
        name: "Stok Kodu: AAAAAA",
        material: "01_default",
    },
    "#c1dc39" : {
        display: "Fıstık Yeşili 3M 1080 Light Serisi",
        name: "Stok Kodu: AAAAAA",
        material: "01_default",
    },
    "#f1eb3b" : {
        display: "Portland 3M 1080 Light  Serisi",
        name: "Stok Kodu: AAAAAA",
        material: "01_default",
    },
    "#f1c107" : {
        display: "Umutsuz Günbatımı 3M 1080 Light Serisi",
        name: "Stok Kodu: AAAAAA",
        material: "01_default",
    },
    "#f19800" : {
        display:"Balkabağı 3M 1080 Light Serisi",
        name: "Stok Kodu: AAAAAA",
        material: "01_default",
    },
    "#f15722" : {
        display: "Yanardağ Kırmızısı 3M 1080 Light Serisi",
        name: "Stok Kodu: AAAAAA",
        material: "01_default",
    },
    "#617d8b" : {
        display: "Palatin Gri 3M 1080 Light Serisi",
        name: "Stok Kodu: AAAAAA",
        material: "01_default",
    },
}

export const palette_3m_2080 = {
    "#ffffff" : {
        display: "Kaplama Yok",
        name: "Stok Kodu: AAAAAA",
        material: "01_default",
    },
    "#f44336" : {
        display: "Uzaysal Turuncu 3M 2080 Pro Serisi",
        name: "Stok Kodu: AAAAAA",
        material: "02_shiny",
    },
    "#e91e63" : {
        display: "Pictorial Carmine 3M 2080 Pro Serisi",
        name: "Stok Kodu: AAAAAA",
        material: "02_shiny",
    },
    "#9c27b0" : {
        display: "Amethyst Mor 3M 2080 Pro Serisi",
        name: "Stok Kodu: AAAAAA",
        material: "02_shiny",
    },
    "#673ab7" : {
        display: "Konstantinapol 3M 2080 Pro  Serisi",
        name: "Stok Kodu: AAAAAA",
        material: "02_shiny",
    },
    "#3f51b5" : {
        display: "Gök Mavisi 3M 2080 Pro Serisi",
        name: "Stok Kodu: AAAAAA",
        material: "02_shiny",
    },
    "#2196f3" : {
        display: "Soylu Safir 3M 2080 Pro Serisi",
        name: "Stok Kodu: AAAAAA",
        material: "02_shiny",
    },
    "#03a9f4" : {
        display: "Deniz Mavisi 3M 2080 Pro Serisi",
        name: "Stok Kodu: AAAAAA",
        material: "02_shiny",
    },
    "#00bcd4" : {
        display: "Turkuaz 3M 2080 Pro Serisi",
        name: "Stok Kodu: AAAAAA",
        material: "02_shiny",
    },
    "#009688" : {
        display: "Meşe Ağacı 3M 2080 Pro Serisi",
        name: "Stok Kodu: AAAAAA",
        material: "02_shiny",
    },
    "#4caf50" : {
        display: "Pistachio 3M 2080 Pro Serisi",
        name: "Stok Kodu: AAAAAA",
        material: "02_shiny",
    },
    "#8bc34a" : {
        display: "Eyfel Kulesi 3M 2080 Pro Serisi",
        name: "Stok Kodu: AAAAAA",
        material: "02_shiny",
    },
    "#cddc39" : {
        display: "Fıstık Yeşili 3M 2080 Pro Serisi",
        name: "Stok Kodu: AAAAAA",
        material: "02_shiny",
    },
    "#ffeb3b" : {
        display: "Portland 3M 2080 Pro Serisi",
        name: "Stok Kodu: AAAAAA",
        material: "02_shiny",
    },
    "#ffc107" : {
        display: "Umutsuz Günbatımı 3M 2080 Pro Serisi",
        name: "Stok Kodu: AAAAAA",
        material: "02_shiny",
    },
    "#ff9800" : {
        display:"Balkabağı 3M 2080 Pro Serisi",
        name: "Stok Kodu: AAAAAA",
        material: "02_shiny",
    },
    "#ff5722" : {
        display: "Yanardağ Kırmızısı 3M 2080 Pro Serisi",
        name: "Stok Kodu: AAAAAA",
        material: "02_shiny",
    },
    "#607d8b" : {
        display: "Palatin Gri 3M 2080 Pro Serisi",
        name: "Stok Kodu: AAAAAA",
        material: "02_shiny",
    },
}

export const palette_3m_3080 = {
    "#ffffff" : {
        display: "Kaplama Yok",
        name: "Stok Kodu: AAAAAA",
        material: "01_default",
    },
    "#f44336" : {
        display: "Uzaysal Turuncu 3M 3080 Ultra Serisi",
        name: "Stok Kodu: AAAAAA",
        material: "03_carbon_fiber",
    },
    "#e91e63" : {
        display: "Pictorial Carmine 3M 3080 Ultra Serisi",
        name: "Stok Kodu: AAAAAA",
        material: "03_carbon_fiber",
    },
    "#9c27b0" : {
        display: "Amethyst Mor 3M 3080 Ultra Serisi",
        name: "Stok Kodu: AAAAAA",
        material: "03_carbon_fiber",
    },
    "#673ab7" : {
        display: "Konstantinapol 3M 3080 Ultra Serisi",
        name: "Stok Kodu: AAAAAA",
        material: "03_carbon_fiber",
    },
    "#3f51b5" : {
        display: "Gök Mavisi 3M 3080 Ultra Serisi",
        name: "Stok Kodu: AAAAAA",
        material: "03_carbon_fiber",
    },
    "#2196f3" : {
        display: "Soylu Safir 3M 3080 Ultra Serisi",
        name: "Stok Kodu: AAAAAA",
        material: "03_carbon_fiber",
    },
    "#03a9f4" : {
        display: "Deniz Mavisi 3M 3080 Ultra Serisi",
        name: "Stok Kodu: AAAAAA",
        material: "03_carbon_fiber",
    },
    "#00bcd4" : {
        display: "Turkuaz 3M 3080 Ultra Serisi",
        name: "Stok Kodu: AAAAAA",
        material: "03_carbon_fiber",
    },
    "#009688" : {
        display: "Meşe Ağacı 3M 3080 Ultra Serisi",
        name: "Stok Kodu: AAAAAA",
        material: "03_carbon_fiber",
    },
    "#4caf50" : {
        display: "Pistachio 3M 3080 Ultra Serisi",
        name: "Stok Kodu: AAAAAA",
        material: "03_carbon_fiber",
    },
    "#8bc34a" : {
        display: "Eyfel Kulesi 3M 3080 Ultra Serisi",
        name: "Stok Kodu: AAAAAA",
        material: "03_carbon_fiber",
    },
    "#cddc39" : {
        display: "Fıstık Yeşili 3M 3080 Ultra Serisi",
        name: "Stok Kodu: AAAAAA",
        material: "03_carbon_fiber",
    },
    "#ffeb3b" : {
        display: "Portland 3M 3080 Ultra Serisi",
        name: "Stok Kodu: AAAAAA",
        material: "03_carbon_fiber",
    },
    "#ffc107" : {
        display: "Umutsuz Günbatımı 3M 3080 Ultra Serisi",
        name: "Stok Kodu: AAAAAA",
        material: "03_carbon_fiber",
    },
    "#ff9800" : {
        display:"Balkabağı 3M 3080 Ultra Serisi",
        name: "Stok Kodu: AAAAAA",
        material: "03_carbon_fiber",
    },
    "#ff5722" : {
        display: "Yanardağ Kırmızısı 3M 3080 Ultra Serisi",
        name: "Stok Kodu: AAAAAA",
        material: "03_carbon_fiber",
    },
    "#607d8b" : {
        display: "Palatin Gri 3M 3080 Ultra Serisi",
        name: "Stok Kodu: AAAAAA",
        material: "03_carbon_fiber",
    },
}
